// frontend_MainDashboard/src/hooks/api/useAiApi.ts

import { useCallback } from 'react';
import { useApiBase } from './useApiBase';

export interface AiApiHook {
  // AI Triggers management
  fetchAiTriggers: () => Promise<{ success: boolean; triggers?: any[]; message?: string }>;
  createAiTrigger: (payload: any) => Promise<{ success: boolean; trigger?: any; message?: string }>;
  updateAiTrigger: (triggerId: string, payload: any) => Promise<{ success: boolean; trigger?: any; message?: string }>;
  deleteAiTrigger: (triggerId: string) => Promise<{ success: boolean; message?: string }>;
}

export const useAiApi = (): AiApiHook => {
  const { makeRequest } = useApiBase();

  const fetchAiTriggers = useCallback((): Promise<{ success: boolean; triggers?: any[]; message?: string }> => {
    return makeRequest<{ success: boolean; triggers?: any[]; message?: string }>('/client/ai_triggers', 'GET');
  }, [makeRequest]);
  
  const createAiTrigger = useCallback((payload: any): Promise<{ success: boolean; trigger?: any; message?: string }> => {
    return makeRequest<{ success: boolean; trigger?: any; message?: string }, any>('/client/ai_triggers', 'POST', payload);
  }, [makeRequest]);
  
  const updateAiTrigger = useCallback((triggerId: string, payload: any): Promise<{ success: boolean; trigger?: any; message?: string }> => {
    return makeRequest<{ success: boolean; trigger?: any; message?: string }, any>(`/client/ai_triggers/${triggerId}`, 'PUT', payload);
  }, [makeRequest]);
  
  const deleteAiTrigger = useCallback((triggerId: string): Promise<{ success: boolean; message?: string }> => {
    return makeRequest<{ success: boolean; message?: string }>(`/client/ai_triggers/${triggerId}`, 'DELETE');
  }, [makeRequest]);

  return {
    fetchAiTriggers,
    createAiTrigger,
    updateAiTrigger,
    deleteAiTrigger,
  };
};
